import React from "react";

const Card = ({
  height = "300px",
  width = "300px",
  backgroundColor = "#fff",
  color = "#000",
  paddingTop = "55px",
  borderRadius = "8px",
  children,
}) => {
  return (
    <div
      className="card"
      style={{
        height: height,
        width: width,
        backgroundColor: backgroundColor,
        color: color,
        boxShadow: "1px 0 7px 0 rgba(1.5, 1.5, 0.5, .5)",
        borderRadius: borderRadius,
        paddingTop: paddingTop,
      }}
    >
      {children}
    </div>
  );
};

export default Card;
